import React from "react";
import '../styles/Footer.css';
function Footer() {
            return (
                <footer className="footer">
                    <div className="container">
                        <div className="footer-container">
                            <div className="footer-column">
                                <a href="#" className="footer-logo">Mammoth Pharmatech</a>
                                <p className="footer-desc">
                                    A trusted partner in the pharmaceutical industry, offering comprehensive solutions that bridge the gap between 
                                    technical requirements and commercial viability.
                                </p>
                            </div>
                            <div className="footer-column">
                                <h3>Quick Links</h3>
                                <ul className="footer-links">
                                    <li><a href="#home">Home</a></li>
                                    <li><a href="#about">About Us</a></li>
                                    <li><a href="/productsPage">Products</a></li>
                                    <li><a href="#contact">Contact</a></li>
                                </ul>
                            </div>
                            <div className="footer-column">
                                <h3>Contact Info</h3>
                                <div className="footer-contact-item">
                                    <i className="fas fa-brands fa-whatsapp footer-contact-icon"></i>
                                    <span>+91 90293 93778</span>
                                </div>
                                <div className="footer-contact-item">
                                    <i className="fas fa-envelope footer-contact-icon"></i>
                                    <span>contact@mammothpharma.com</span>
                                </div>
                                <div className="footer-contact-item">
                                    <i className="fas fa-map-marker-alt footer-contact-icon"></i>
                                    <span> South Mumbai, India - 400002</span>
                                </div>
                                <div className="footer-contact-item">
                                    <a href="https://www.linkedin.com/company/mammoth-pharmatech" className=""><i className="fab fa-linkedin-in footer-contact-icon"></i><span className="footer-social">LinkedIn</span></a>
                                    {/* <a href="#" className="social-icon"><i className="fab fa-instagram"></i></a>
                                    <a href="#" className="social-icon"><i className="fab fa-facebook-f"></i></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="footer-bottom">
                            <p>&copy; 2025 Mammoth Pharmatech. All Rights Reserved.</p>
                        </div>
                    </div>
                </footer>
            );
        }
export default Footer;